import React from 'react';
import { ChevronLeft, MoreVertical, CheckCircle2, Copy, Share2, ShieldCheck } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen3({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-slate-50 flex flex-col pb-24" data-id="element-105">
      {/* Header */}
      <div className="px-4 py-4 bg-white flex items-center justify-between sticky top-0 z-10 border-b border-slate-100" data-id="element-106">
        <button onClick={() => onNavigate(2)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-107">
          <ChevronLeft className="w-6 h-6" data-id="element-108" />
        </button>
        <h1 className="text-base font-bold text-datmont-900" data-id="element-109">
          Document Details
        </h1>
        <button className="p-2 -mr-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-110">
          <MoreVertical className="w-5 h-5" data-id="element-111" />
        </button>
      </div>

      <div className="flex-1 px-6 py-6 space-y-6" data-id="element-112">
        {/* Document Header */}
        <div className="flex items-center gap-4" data-id="element-113">
          <div className="w-14 h-14 rounded-full bg-slate-800 flex items-center justify-center text-white font-serif font-bold border-2 border-yellow-500 shadow-sm" data-id="element-114">
            FBI
          </div>
          <div data-id="element-115">
            <h2 className="text-lg font-bold text-datmont-900" data-id="element-116">
              FBI Identity Record
            </h2>
            <p className="text-xs text-slate-500" data-id="element-117">
              Document Type: Background Check
            </p>
          </div>
        </div>

        {/* Authentic Status Box */}
        <div className="bg-green-50 border border-green-200 rounded-2xl p-5 flex flex-col items-center text-center" data-id="element-118">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mb-3" data-id="element-119">
            <CheckCircle2 className="w-6 h-6 text-datmont-green" data-id="element-120" />
          </div>
          <h3 className="text-lg font-bold text-datmont-green mb-1" data-id="element-121">
            Authentic
          </h3>
          <p className="text-xs text-green-700/80 leading-relaxed" data-id="element-122">
            This document has been verified and issued by the correct authority.
          </p>
        </div>

        {/* Verification Checklist */}
        <div className="space-y-5 px-2" data-id="element-123">
          <div className="flex gap-3" data-id="element-124">
            <CheckCircle2 className="w-5 h-5 text-datmont-green shrink-0" data-id="element-125" />
            <div data-id="element-126">
              <p className="text-sm font-bold text-datmont-900" data-id="element-127">
                Issuer Verified
              </p>
              <p className="text-xs text-slate-500" data-id="element-128">
                Federal Bureau of Investigation (FBI)
              </p>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-129">
            <CheckCircle2 className="w-5 h-5 text-datmont-green shrink-0" data-id="element-130" />
            <div data-id="element-131">
              <p className="text-sm font-bold text-datmont-900" data-id="element-132">
                Integrity Confirmed
              </p>
              <p className="text-xs text-slate-500" data-id="element-133">No tampering detected.</p>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-134">
            <CheckCircle2 className="w-5 h-5 text-datmont-green shrink-0" data-id="element-135" />
            <div data-id="element-136">
              <p className="text-sm font-bold text-datmont-900" data-id="element-137">Valid Until</p>
              <p className="text-xs text-slate-500" data-id="element-138">October 12, 2026</p>
            </div>
          </div>
        </div>

        {/* Seal ID */}
        <button onClick={() => onNavigate(9)} className="w-full bg-white border border-slate-200 rounded-xl p-4 flex items-center justify-between shadow-sm hover:border-datmont-blue/50 hover:shadow-md transition-all text-left group" data-id="element-139">
          <div data-id="element-140">
            <p className="text-[10px] font-medium text-slate-400 uppercase tracking-wider mb-1 group-hover:text-datmont-blue transition-colors" data-id="element-141">Datmont Seal ID</p>
            <p className="text-sm font-mono font-bold text-datmont-900" data-id="element-142">DMT-8847291</p>
          </div>
          <div className="p-2 text-slate-400 group-hover:text-datmont-blue group-hover:bg-blue-50 rounded-lg transition-colors" data-id="element-143">
            <Copy className="w-4 h-4" data-id="element-144" />
          </div>
        </button>

        {/* Issued On */}
        <div className="px-2" data-id="element-145">
          <p className="text-[10px] font-medium text-slate-400 uppercase tracking-wider mb-1" data-id="element-146">
            Issued On
          </p>
          <p className="text-xs font-medium text-datmont-900" data-id="element-147">
            March 12, 2024{' '}
            <span className="text-slate-500 ml-1" data-id="element-148">09:14 AM UTC</span>
          </p>
        </div>
      </div>

      {/* Bottom Actions */}
      <div className="absolute bottom-0 inset-x-0 bg-white border-t border-slate-100 p-4 flex gap-3" data-id="element-149">
        <button className="flex-1 py-3.5 bg-white border border-slate-200 text-datmont-900 text-sm font-medium rounded-xl flex items-center justify-center gap-2 shadow-sm hover:bg-slate-50 transition-colors" data-id="element-150">
          <Share2 className="w-4 h-4" data-id="element-151" /> Share Securely
        </button>
        <button onClick={() => onNavigate(4)} className="flex-1 py-3.5 bg-datmont-900 text-white text-sm font-medium rounded-xl flex items-center justify-center gap-2 shadow-md hover:bg-datmont-800 transition-colors" data-id="element-152">
          <ShieldCheck className="w-4 h-4" data-id="element-153" /> Verify with Institution
        </button>
      </div>
    </div>;
}